import { append, concat, map, reduce } from "ramda"

export const mapTableData = (array: any[]) =>
  reduce(
    (accumulator: any[], item: any) => {
      const resultItem = { ...item, sectionPath: [item.id] }

      if (item.isSection) {
        return concat(
          [...accumulator, resultItem],
          map((data) => ({ ...data, sectionPath: [item.id, data.id] }), item.questions),
        )
      }

      return append(resultItem, accumulator)
    },
    [],
    array,
  )
